import script from "./ProgramsIncubeView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramsIncubeView.vue?vue&type=script&setup=true&lang=js"

import "./ProgramsIncubeView.vue?vue&type=style&index=0&id=7b0970a3&lang=css"

const __exports__ = script;

export default __exports__